import SEO, { pageSEO } from "../components/seo.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faHouse,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";

export default function Calculator() {
  const seoConfig = pageSEO.calculator();

  return (
    <>
      <SEO {...seoConfig} />

      {/* Hero */}
      <section className="relative overflow-hidden bg-harbour-navy pt-40 pb-28">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="relative mx-auto max-w-7xl px-6 text-center">
          <motion.p
            variants={fadeUp}
            className="uppercase tracking-[0.4em] text-harbour-sky">
            Financial Tools
          </motion.p>

          <motion.h1
            variants={fadeUp}
            className="mt-5 text-4xl md:text-5xl font-light uppercase tracking-wider text-white md:text-6xl">
            Mortgage Calculator
          </motion.h1>

          <motion.div
            variants={fadeUp}
            className="mx-auto mt-6 h-0.5 w-24 bg-harbour-sky" />

          <motion.p
            variants={fadeUp}
            className="mx-auto mt-8 max-w-3xl text-lg leading-8 text-white/80">
            Estimate your monthly mortgage payments and better understand
            what fits comfortably within your budget before purchasing your
            next home.
          </motion.p>
        </motion.div>
      </section>

      {/* Info Cards */}
      <motion.section
        variants={stagger}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        className="mx-auto mt-16 max-w-7xl px-6">
        <motion.div
          variants={fadeUp}
          className="grid gap-6 rounded-2xl md:grid-cols-3">
          <div className="rounded-2xl bg-white p-8 shadow-xl">
            <FontAwesomeIcon
              icon={faCalculator}
              className="mb-5 text-3xl text-harbour-accent"
            />

            <h3 className="text-xl font-medium text-harbour-navy">
              Estimate Payments
            </h3>

            <p className="mt-3 leading-7 text-harbour-navy">
              Quickly calculate your monthly mortgage payments using current
              loan estimates.
            </p>
          </div>

          <div className="rounded-2xl bg-white p-8 shadow-xl">
            <FontAwesomeIcon
              icon={faDollarSign}
              className="mb-5 text-3xl text-harbour-accent"
            />

            <h3 className="text-xl font-medium text-harbour-navy">
              Budget Better
            </h3>

            <p className="mt-3 leading-7 text-harbour-navy">
              Compare different down payments and interest rates to plan your
              purchase confidently.
            </p>
          </div>

          <div className="rounded-2xl bg-white p-8 shadow-xl">
            <FontAwesomeIcon
              icon={faHouse}
              className="mb-5 text-3xl text-harbour-accent"
            />

            <h3 className="text-xl font-medium text-harbour-navy">
              Buy With Confidence
            </h3>

            <p className="mt-3 leading-7 text-harbour-navy">
              Understand affordability before beginning your home search.
            </p>
          </div>

        </motion.div>
      </motion.section>

      {/* Calculator */}
      <motion.section
        variants={stagger}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        className="mx-auto max-w-7xl px-6 py-20">
        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-2xl">

          <motion.div
            variants={fadeUp}
            className="border-b border-slate-200 bg-slate-50 px-8 py-6">
            <h2 className="text-2xl font-light uppercase tracking-wide text-summit-primary">
              Mortgage Payment Calculator
            </h2>

            <p className="mt-2 text-summit-tertiary">
              Adjust the values below to see how your monthly payment changes.
            </p>
          </motion.div>

          <motion.iframe
            variants={fadeUp}
            src="https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=400000&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0"
            className="h-[2400px] w-full border-0 md:h-[1200px]"
            scrolling="no"
            title="Mortgage Calculator"
          />
        </div>
      </motion.section>
    </>
  );
}